import { Toaster } from 'sonner';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';

function RedirectProgramSlug() {
  const { programSlug } = useParams();
  return <Navigate to={`/courses/${programSlug}`} replace />;
}
function RedirectProgramCourse() {
  const { programSlug, courseSlug } = useParams();
  return <Navigate to={`/courses/${programSlug}/courses/${courseSlug}`} replace />;
}
function RedirectProgramCourseSection() {
  const { programSlug, courseSlug, sectionId } = useParams();
  return <Navigate to={`/courses/${programSlug}/courses/${courseSlug}/sections/${sectionId}`} replace />;
}
import { AuthProvider } from '@/contexts/AuthContext';
import { SiteConfigProvider } from '@/contexts/SiteConfigContext';
import { CurrencyProvider } from '@/contexts/CurrencyContext';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { SignInFeedback } from '@/components/SignInFeedback';
import { Home } from '@/pages/Home';
import { About } from '@/pages/About';
import { Ecosystem } from '@/pages/Ecosystem';
import { Programs } from '@/pages/Programs';
import { ProgramDetailPage } from '@/pages/ProgramDetailPage';
import { CourseDetailPage } from '@/pages/CourseDetailPage';
import { LessonViewPage } from '@/pages/LessonViewPage';
import { ReferralPage } from '@/pages/ReferralPage';
import { Contact } from '@/pages/Contact';
import { Careers } from '@/pages/Careers';
import { InviteAcceptPage } from '@/pages/InviteAcceptPage';
import { Login } from '@/pages/Login';
import { Admin } from '@/pages/Admin';
import { TutorAcceptInvitePage } from '@/pages/TutorAcceptInvitePage';
import { TutorDashboardPage } from '@/pages/TutorDashboardPage';
import { HomeworkPage } from '@/pages/HomeworkPage';
import { StudentDashboardPage } from '@/pages/StudentDashboardPage';
import { NotFound } from '@/pages/NotFound';

function App() {
  return (
    <>
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <AuthProvider>
          <SiteConfigProvider>
            <CurrencyProvider>
            <SignInFeedback />
            <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/ecosystem" element={<Layout><Ecosystem /></Layout>} />
            <Route path="/courses" element={<Layout><Programs /></Layout>} />
            <Route path="/courses/:programSlug" element={<Layout><ProgramDetailPage /></Layout>} />
            <Route path="/courses/:programSlug/courses/:courseSlug" element={<Layout><CourseDetailPage /></Layout>} />
            <Route path="/courses/:programSlug/courses/:courseSlug/sections/:sectionId" element={<Layout><LessonViewPage /></Layout>} />
            <Route path="/programs" element={<Navigate to="/courses" replace />} />
            <Route path="/programs/:programSlug" element={<RedirectProgramSlug />} />
            <Route path="/programs/:programSlug/courses/:courseSlug" element={<RedirectProgramCourse />} />
            <Route path="/programs/:programSlug/courses/:courseSlug/sections/:sectionId" element={<RedirectProgramCourseSection />} />
            <Route path="/referral" element={<Layout><ReferralPage /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/careers" element={<Layout><Careers /></Layout>} />
            <Route path="/invite/accept/:token" element={<Layout><InviteAcceptPage /></Layout>} />
            <Route path="/login" element={<Layout><Login /></Layout>} />
            <Route
              path="/admin"
              element={
                <Layout>
                  <ProtectedRoute role="admin">
                    <Admin />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route path="/tutor/accept-invite" element={<TutorAcceptInvitePage />} />
            <Route
              path="/tutor/dashboard"
              element={
                <Layout>
                  <ProtectedRoute role="tutor">
                    <TutorDashboardPage />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/homework"
              element={
                <Layout>
                  <ProtectedRoute>
                    <HomeworkPage />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <ProtectedRoute>
                    <StudentDashboardPage />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route path="*" element={<Layout><NotFound /></Layout>} />
            </Routes>
            </CurrencyProvider>
          </SiteConfigProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
